import { AfterViewInit, ChangeDetectionStrategy, Component, input, OnInit, signal } from "@angular/core";
import { animate, style, transition, trigger } from "@angular/animations";

//local imports
import { Transforms } from "@app/shared";
import { IMenu } from "@app/core";

@Component({
  selector: "menu",
  templateUrl: "./menu.component.html",
  styleUrl: "./menu.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
  animations: [
    trigger("submenuAnimation", [
      transition(":enter", [
        style({
          opacity: 0,
          transform: "translateX(-10px)",
        }),
        animate(
          "300ms ease-out",
          style({
            opacity: 1,
            transform: "translateX(0)",
          }),
        ),
      ]),
      transition(":leave", [
        animate(
          "300ms ease-in",
          style({
            opacity: 0,
            transform: "translateX(-10px)",
          }),
        ),
      ]),
    ]),
  ],
})
export class MenuComponent {
  public menu = input.required<IMenu>();

  public isCollapsed = signal<boolean>(false);

  public collapsible = input(false, {
    transform: Transforms.toBoolean,
  });

  public toggleMenu(collapsed: boolean) {
    this.isCollapsed.set(collapsed);
  }
}
